// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-block[data-v-724c479a] {\n  font-size: 28px;\n  margin-right: 12px;\n  margin-top: 4px;\n}", ""]);
// Exports
module.exports = exports;
